import React, { CSSProperties, ReactNode } from 'react';
import bem from '../../../lib/bemUtils/bem';
import { Modifier } from '../../../lib/bemUtils/Modifier';

export enum IFrameContainerModifier {
  NO_PADDING = 'no-padding',
}

type ExternalContentProps = {
  modifier?: Modifier<IFrameContainerModifier>;
  style?: CSSProperties;
  children: ReactNode;
};
export function IFrameContainer({ modifier, style, children }: ExternalContentProps) {
  return (
    <div className={bem('iframe__container', modifier)} style={style}>
      {children}
    </div>
  );
}
